/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component } from 'react'

import { StyledText } from '@skytech/ui'
import ThumbDownIcon from 'mdi-react/ThumbDownIcon'
import ThumbUpIcon from 'mdi-react/ThumbUpIcon'

import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import { numberFormat } from '@/util/formatters/numbers'

import { Translation } from '../i18n/Translation'

export default class SalaryDeductionSummary extends Component {
  // @ts-ignore
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    // @ts-ignore
    const invoices = this.props.invoices
    // @ts-ignore
    const offset = this.props.offset
    // @ts-ignore
    const invoice = this.props.currentInvoice
    const prev_invoice = offset < invoices.length - 1 ? invoices[offset + 1] : null

    if (!invoice || !prev_invoice) return null

    const current_total = invoice.amount + invoice.vat
    const prev_total = prev_invoice.amount + prev_invoice.vat

    // @ts-ignore
    function percent(current_total, prev_total) {
      const percentage =
        current_total < prev_total ? 1 - current_total / prev_total : current_total / prev_total - 1

      return (
        <div>
          <StyledText
            className="percentage"
            size="xxl"
            colorMode={current_total > prev_total ? 'red' : 'green'}
          >
            {current_total > prev_total ? <ThumbDownIcon /> : <ThumbUpIcon />}
            {numberFormat(Math.abs(percentage * 100), 2)}%
          </StyledText>
        </div>
      )
    }

    return (
      <div id="invoice-change" className="section">
        {percent(current_total, prev_total)}
        <StyledText colorMode="gray">
          {current_total > prev_total ? (
            <Translation id="Økning fra forrige periode" />
          ) : (
            <Translation id="Reduksjon fra forrige periode" />
          )}
        </StyledText>

        <div>
          <StyledText colorMode="gray" size="regular-plus">
            <FormattedNumberWithCurrency amount={prev_total} precision={2} />
          </StyledText>
        </div>
      </div>
    )
  }
}
